import { Component } from '@angular/core';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@openng/optimus-ui/tabs';
import { TranslatePipe } from '@ngx-translate/core';
import {
    VoucherDetailPrescriptionsMedicalProceduresComponent,
} from '../voucher-detail-prescriptions-medical-procedures/voucher-detail-prescriptions-medical-procedures.component';

@Component({
    selector: 'app-voucher-detail-prescriptions',
    templateUrl: './voucher-detail-prescriptions.component.html',
    styleUrls: ['./voucher-detail-prescriptions.component.scss'],
    imports: [
        Tabs,
        TabList,
        Tab,
        TranslatePipe,
        TabPanels,
        TabPanel,
        VoucherDetailPrescriptionsMedicalProceduresComponent,
    ],
})
export class VoucherDetailPrescriptionsComponent {
}
